import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { EMPTY_OBJECT } from '../../constants';
import Style from '../Style';
import { L2, P2 } from '../Typography';

const BASE_STYLE = {
  border: 'none',
  width: '100%',
};

export class Form extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func,
    style: PropTypes.object,
  };
  static defaultProps = {
    onSubmit: () => {},
    style: EMPTY_OBJECT,
  };

  onSubmitForm = e => {
    e.preventDefault();
    this.props.onSubmit();
  };

  render() {
    return (
      <form
        style={{
          ...BASE_STYLE,
          ...{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          },
          ...this.props.style,
        }}
        onSubmit={this.onSubmitForm}
      >
        {this.props.children}
        <button hidden type="submit" />
      </form>
    );
  }
}

export class Input extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    labelStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    textColor: PropTypes.object,
    placeHolder: PropTypes.string,
  };
  static defaultProps = {
    onChange: value => {},
    labelStyle: EMPTY_OBJECT,
    inputStyle: EMPTY_OBJECT,
    onFocus: () => {},
    onBlur: () => {},
    textColor: Color(Style.Colors.shadow3),
  };

  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };
  }

  changeInput = e => {
    this.props.onChange(e.target.value, e.target.name);
  };

  onFocus = e => {
    this.setState({ focused: true });
    this.props.onFocus(e);
  };

  onBlur = e => {
    this.setState({ focused: false });
    this.props.onBlur(e);
  };

  focus = () => {
    this.formFieldRef.focus();
  };

  render() {
    const {
      name,
      type,
      value,
      onChange,
      labelStyle,
      style,
      inputStyle,
      children,
      textColor,
      placeHolder,
      ...otherProps
    } = this.props;

    const labelStyleMerged = {
      ...BASE_STYLE,
      color: textColor.alpha(0.5).string(),
      fontStyle: 'italic',
      fontWeight: 'light',
      fontSize: '2.6rem',
      letterSpacing: -0.18,
      marginTop: '2.5rem',
      display: 'block',
      ...labelStyle,
    };
    if (this.props.value && this.state.focused) {
      labelStyleMerged.color = textColor.string();
    }

    const inputStyleMerged = {
      ...BASE_STYLE,
      color: textColor.alpha(0.5).string(),
      borderBottom: `0.1rem solid ${Style.Colors.shadow3}`,
      backgroundColor: 'transparent',
      fontSize: '2rem',
      lineHeight: '1.6em',
      marginTop: '0.7rem',
      ...inputStyle,
    };
    if (this.props.value) {
      inputStyleMerged.color = textColor.string();
    }

    return (
      <label style={labelStyleMerged}>
        <div>
          <L2 style={{ color: 'inherit' }}>{children}</L2>
        </div>
        <input
          {...otherProps}
          style={inputStyleMerged}
          name={name}
          type={type}
          value={value}
          onChange={this.changeInput}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          placeholder={placeHolder}
          ref={ref => (this.formFieldRef = ref)}
        />
      </label>
    );
  }
}

export class Checkbox extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    labelStyle: PropTypes.object,
    inputStyle: PropTypes.object,
  };
  static defaultProps = {
    onChange: value => {},
    labelStyle: EMPTY_OBJECT,
    inputStyle: EMPTY_OBJECT,
  };

  changeInput = e => {
    this.props.onChange(!this.props.checked, this.props.name);
  };

  render() {
    const { name, checked, onChange, labelStyle, inputStyle, children, ...otherProps } = this.props;

    return (
      <label
        style={{
          display: 'block',
        }}
      >
        <input
          name={name}
          type="checkbox"
          checked={checked}
          onChange={this.changeInput}
          style={inputStyle}
        />
        <P2
          style={{
            marginLeft: '0.5rem',
            display: 'inline',
            ...labelStyle,
          }}
        >
          {children}
        </P2>
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Form.js